import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import Alert from '../Alert';
import { ajaxFeedbackTags } from '../redux/FeedbackRedux';

class TagsSection extends React.Component {
      constructor(props) {
            super(props);
            this.handleChange = this.handleChange.bind(this);
            this.state = {is_open: false};
      }

      handleOpenChange(event) {
            event.preventDefault();
            this.setState({
                  is_open: !this.state.is_open,
            });
      }

      handleChange(selectedTags) {
            var tags = []
            for (var tag in selectedTags) {
                  tags.push(selectedTags[tag].value);
            }

            this.props.dispatch(ajaxFeedbackTags(this.props.feedback.feedback_id, tags));
      }

      render() {
          const options = [];
          for (const tag in this.props.tags) {
                  if (this.props.tags[tag].is_active !== 0) {
                        options.push({ value: this.props.tags[tag].id, label: this.props.tags[tag].label });
                  }
            }

          let defaultOptions = [];
          for (const i in this.props.feedback.feedback_tags) {
                  if (this.props.feedback.feedback_tags[i].is_active === 1) {
                      const match = options.find(
                          element => element.value === this.props.feedback.feedback_tags[i].tags_id
                      );
                      if (match) {
                          match.is_ai_generated = this.props.feedback.feedback_tags[i].auto_generated_at !== null
                          defaultOptions.push(match);
                      }
                  }
            }

            // Mark it with AI generated icon
            defaultOptions = defaultOptions.map(tag => {
              const aiIcon = '<svg class="mr-1" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.15.025c.101.036.19.106.253.202.063.095.097.21.097.328v2.778h2c.091 0 .181.028.26.08a.537.537 0 0 1 .183.219.608.608 0 0 1-.033.575l-3.5 5.555a.509.509 0 0 1-.249.208c-.1.038-.21.04-.311.004a.505.505 0 0 1-.253-.201.598.598 0 0 1-.097-.329V6.666h-2a.463.463 0 0 1-.26-.08.536.536 0 0 1-.183-.218.608.608 0 0 1 .033-.576L3.59.237a.509.509 0 0 1 .249-.208c.1-.038.21-.039.311-.003Z" fill="#3775B7"></path></svg>';
              const label = tag.is_ai_generated ? `${aiIcon}${tag.label}` : tag.label;

              return {
                  ...tag,
                  label,
              };
            });

            return (
                  <div className="card-body pb-4 border-top tag-section">
                        <Alert alert={this.props.alert} location={'tags'} />
                        <div className="d-flex align-items-center mb-2">
                              <h4 className='mb-0' data-toggle="tooltip" data-title={ __('Categorizes Feedbacks for easy labeling and search-ability')}>{__('Tags')}</h4>
                              {!defaultOptions || defaultOptions?.length < 1 &&
                                    <div className="ml-2">
                                          {!this.state.is_open &&
                                                <span className="btn btn-sm btn-primary toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                                      <i className="far fa-plus"></i>
                                                </span>
                                          }
                                          {this.state.is_open &&
                                                <span className="btn btn-sm btn-primary btn-primary-alt toggle-notes ml-3 d-inline-block" onClick={this.handleOpenChange.bind(this)}>
                                                      <i className="far fa-times"></i>
                                                </span>
                                          }
                                    </div>
                              }
                        </div>

                        <div className="row tags">
                              <div className="col-md-12">
                                    {(this.props.current_user && (this.state.is_open || defaultOptions.length > 0)) &&
                                          <Select
                                              formatOptionLabel={({ label }) => (
                                                  <div className="pr-3" dangerouslySetInnerHTML={{ __html: label }} />
                                              )}
                                              className="react-select-container w-100 " classNamePrefix="react-select" isMulti value={defaultOptions} onChange={this.handleChange} options={options} placeholder={__('Select')} />
                                    }
                                    {(!this.props.current_user && (this.state.is_open || defaultOptions.length > 0)) &&
                                          <Select className="react-select-container w-100" classNamePrefix="react-select" isDisabled={true} isMulti value={defaultOptions} onChange={this.handleChange} options={options} placeholder={__('Select')} />
                                    }
                              </div>
                        </div>
                  </div>
            );
      }
}

function mapStateToProps(state) {
      return { tag_state: state.tag_state, tags: state.feedback_detail.business.tags, feedback: state.feedback_detail, alert: state.alert.alert }
}

export default connect(mapStateToProps)(TagsSection)
